import { render, staticRenderFns } from "./CourseOutlineInfo.vue?vue&type=template&id=5baf6581&scoped=true&"
import script from "./CourseOutlineInfo.vue?vue&type=script&lang=js&"
export * from "./CourseOutlineInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baf6581",
  null
  
)

export default component.exports